import { NgModule } from '@angular/core';
import { AuthTokenService } from './auth-token/auth-token.service';
import { AuthDataService } from './authentication/auth-data.service';

@NgModule({
  providers: [AuthTokenService, AuthDataService]
})
export class HTTPServicesModule {}
